import React from 'react';
import { Button, Paper, Typography } from "@mui/material";
import PropTypes from 'prop-types';

export const ActionMessage = ({ content, timestamp, buttonText, url }) => {
    const handleButtonClick = () => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    // Formatear el timestamp para mostrar solo la hora
    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    return (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "8px" }}>
            <Paper
                elevation={0}
                style={{
                    backgroundColor: "#d9fdd3",
                    padding: "6px 0px",
                    borderRadius: "7.5px 7.5px 0 7.5px",
                    maxWidth: "80%",
                    overflowWrap: "break-word",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                    boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
                }}
            >
                <Typography variant="body1" style={{ marginBottom: "8px", padding: "0px 12px" }}>{content}</Typography>
                <Typography variant="caption" style={{ display: "block", textAlign: "right", marginTop: "4px" }}>
                    {timestamp ? formatTime(timestamp) : ""}
                </Typography>

                <div
                    style={{
                        borderTop: "1px solid #ccc",
                    }}
                >
                    {buttonText && url && (
                        <Button
                            startIcon={<span>🔗</span>}
                            variant="text"
                            style={{
                                color: "#008069",
                                textTransform: "none",
                                justifyContent: "center",
                                width: "100%",
                                padding: "8px 0",
                                fontWeight: "500",
                                fontSize: "14px",
                            }}
                            onClick={handleButtonClick}
                        >
                            {buttonText}
                        </Button>
                    )}
                </div>
            </Paper>
        </div>
    );
}

// export const ActionMessage = ({ content, timestamp, buttonText, url }) => {
//     const handleButtonClick = () => {
//         if (url) {
//             window.open(url, '_blank', 'noopener,noreferrer');
//         }
//     };

//     return (
//         <div style={{ display: "flex", flexDirection: "column", maxWidth: "80%" }}>
//             <Paper
//                 elevation={1}
//                 style={{
//                     backgroundColor: "white",
//                     padding: "8px 12px",
//                     borderRadius: "12px",
//                 }}
//             >
//                 <Typography variant="body1">{content}</Typography>
//                 <Typography variant="caption" style={{ display: "block", textAlign: "right", marginTop: "4px" }}>
//                     {timestamp}
//                 </Typography>
//             </Paper>

//             {buttonText && url && (
//                 <Button
//                     variant="outlined"
//                     startIcon={<span>🔗</span>}
//                     style={{
//                         backgroundColor: "white",
//                         color: "#25D366",
//                         borderColor: "#25D366",
//                         marginTop: "8px",
//                         textTransform: "none",
//                         borderRadius: "8px",
//                         fontWeight: 500,
//                     }}
//                     onClick={handleButtonClick}
//                 >
//                     {buttonText}
//                 </Button>
//             )}
//         </div>
//     );
// };


export default ActionMessage;


